/**
 * Centralized React Query key factory for AIChatWidget TOS queries.
 *
 * Using a single factory ensures queries and mutations reference identical
 * keys so `invalidateQueries` triggers refetch correctly.
 */
export const tosKeys = {
    all: ['ai-tos'],
    status: () => [...tosKeys.all, 'status']
};
/** Support-session snapshot (`GET /api/chat/{conversation_id}/support`), one per conversation. */
export const supportKeys = {
    all: ['ai-chat', 'support'],
    state: (conversationId) => [...supportKeys.all, conversationId],
    /** Unread support replies per conversation, from the orchestrator's conversation list. */
    unreadList: () => [...supportKeys.all, 'unread-list'],
    /** The caller's finished live chats (`GET /api/support/sessions`), across conversations. */
    pastChats: () => [...supportKeys.all, 'past-chats']
};
